import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { Text } from '../../ui/Text.js';
import { HighlightAsset } from './HighlightAsset.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HighlightAssetList({
  assets,
  title,
  hasSpacingTop = true,
  anchor,
  style = 'default'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightAssetList",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        hasSpacingHorizontal: true,
        hasSpacingTop: hasSpacingTop,
        anchor: anchor,
        background: background,
        children: [title && /*#__PURE__*/jsx(Text, {
          variant: "title2",
          color: foreground,
          as: "h2",
          spacingEnd: {
            lg: 2
          },
          children: title
        }), /*#__PURE__*/jsx(Div, {
          spacingVertical: 5,
          flexWrap: "wrap",
          children: assets?.map(({
            logoSrc,
            link,
            name
          }, i) => /*#__PURE__*/jsx(AnalyticsProvider, {
            analyticsPrefix: `${ANALYTICS_KEY.Asset}${i}`,
            children: /*#__PURE__*/jsx(Div, {
              spacingEnd: 2,
              spacingTop: 2,
              width: "inherit",
              children: /*#__PURE__*/jsx(HighlightAsset, {
                logoSrc: logoSrc,
                link: link,
                name: name,
                style: style
              })
            })
          }, `${name}-${i}`))
        })]
      })
    })
  });
}
export { HighlightAssetList };
//# sourceMappingURL=HighlightAssetList.js.map
